import { useAction } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { walletProfileModalAtom } from '@root/features/services/wallet-profile'
import { setMakerFilterEvent } from '@root/features/trade/tables/trades-table'
import { FilterButton } from '@root/shared/ui-kit'

import { AuditContractItem } from './audit-contract-item'

import type { Address } from '@root/entities/address/Address'
import type { Network } from '@root/entities/network'

type Props = {
  address: Address | undefined
  network: Network.Network
  filterActive: boolean
}

export const TradingAuditContractItem: React.FC<Props> = ({
  address,
  network,
  filterActive,
}) => {
  const { t } = useTranslation()
  const setMakerFilter = useAction(setMakerFilterEvent)
  // The deployer and the LP creator are wallets, and a wallet's own record is
  // what somebody reading an audit line is actually asking about. The
  // explorer is a click away inside the profile.
  const openProfile = useAction(
    (ctx, walletAddress: Address) =>
      walletProfileModalAtom(ctx, { walletAddress, network }),
    [network],
  )

  if (!address) {
    return (
      <Root>
        <Value>{t('common.n_a')}</Value>
      </Root>
    )
  }

  const handleFilterClick = () => {
    setMakerFilter({ maker: filterActive ? undefined : address })
  }

  return (
    <Root>
      <AuditContractItem
        address={address}
        network={network}
        onClick={() => openProfile(address)}
      />

      <FilterButton
        active={filterActive}
        onClick={handleFilterClick}
        size={16}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  gap: 2px;
`
const Value = styled.div``
